import { BaseModel } from './base.model';

export class TaskChoice extends BaseModel {
  description: string;
  answer: string;
  isCorrect: boolean;
}